import React from 'react';
import { Tooltip } from 'antd';
import { formatMoney } from '../utils/money';
import { t } from '../i18n';

/**
 * 余额展示：后端 balance_view = { balance, currency, display: { amount, currency, rate, as_of, stale } | null }
 * 主值永远是余额币种（现为 USD，显示 $）的存储额；有 display 时在后面附「≈ $X」参考折算，
 * 悬停显示汇率与更新时间。折算仅展示，不影响余额。
 */
export const balanceOriginalText = (view) => {
    if (!view || !view.display) return '';
    const d = view.display;
    const asOf = d.as_of ? ` · ${t('FX rate updated')} ${d.as_of}` : '';
    return `≈${formatMoney(d.amount, d.currency, { original: true })} · 1 ${view.currency} = ${d.rate} ${d.currency}${asOf}${d.stale ? ` (${t('FX rate may be outdated')})` : ''}`;
};

const BalanceMoney = ({ view, noTooltip = false, showApprox = true, style, className }) => {
    if (!view) return null;
    const main = <span style={style} className={className}>{formatMoney(view.balance, view.currency, { original: true })}</span>;
    const d = view.display;
    if (!showApprox || !d || d.amount === null || d.amount === undefined) {
        return main;
    }
    const approx = (
        <span style={{ fontSize: '0.75em', opacity: 0.65, marginLeft: 6, fontWeight: 'normal' }}>
            ≈{formatMoney(d.amount, d.currency, { original: true })}
        </span>
    );
    return (
        <span>
            {main}
            {noTooltip ? approx : <Tooltip title={balanceOriginalText(view)}>{approx}</Tooltip>}
        </span>
    );
};

export default BalanceMoney;
